import React, { createContext, useContext, useEffect } from "react";
import { interceptDemoApi } from "../utils/demoApiInterceptor";
import api from "../api/axiosCfg";

const DemoContext = createContext();

export const useDemo = () => {
  const context = useContext(DemoContext);
  if (!context) {
    throw new Error("useDemo must be used within DemoProvider");
  }
  return context;
};

export const DemoProvider = ({ children }) => {
  useEffect(() => {
    // Intercept API calls (route-based, no localStorage needed)
    interceptDemoApi(api);
  }, []);

  return (
    <DemoContext.Provider value={{ isDemoMode: true }}>
      {children}
    </DemoContext.Provider>
  );
};

export default DemoContext;
